import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import CutterheadLogo from "@/components/CutterheadLogo";
import { useAuth } from "@/context/AuthContext";

const BG = "/login-bg.jpg?v=2";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-surf p-4">
      <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-surf/60 to-surf/98" />
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-2 flex items-center gap-3">
          <CutterheadLogo size={46} />
          <span className="text-4xl font-extrabold tracking-wider text-ink">BoreHub</span>
        </div>
        <p className="mb-8 text-sm tracking-wide text-ink2">Tunnel Boring Machine Maintenance</p>

        <form onSubmit={onSubmit} className="space-y-4 rounded-2xl border border-hairline bg-surf-2/80 p-6 backdrop-blur">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ink2">Email or username</label>
            <input
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none"
              placeholder="you@company.com"
              className="w-full rounded-xl border border-hairline bg-surf px-4 py-3 text-ink outline-none focus:border-brand"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ink2">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full rounded-xl border border-hairline bg-surf px-4 py-3 text-ink outline-none focus:border-brand"
            />
          </div>
          {err ? <p className="text-sm text-danger" data-testid="login-error">{err}</p> : null}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand py-3.5 font-extrabold uppercase tracking-wider text-black transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Sign in"}
            {!loading && <ArrowRight size={20} />}
          </button>
        </form>
      </div>
    </div>
  );
}
